module.exports = __webpack_public_path__ + "img/UTFREM-10.1c37ed4b.jpg";